<template>
	<div class="page-container">
		<div class="md-content">
			<div class="swiper-container">
				<swiper  :options="swiperOption" ref="mySwiper">
					<swiper-slide v-for="img in bannerList">
						<img :src="$VARS.url+img">
					</swiper-slide>
					 <div class="swiper-button-prev" slot="button-prev"></div>
					 <div class="swiper-button-next" slot="button-next"></div>
				</swiper>
			</div>
			<div id="start-button-box">
				<md-button class="md-raised md-primary" @click="start()">시작하기</md-button>
			</div>
		</div>	
	</div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'Intro',
  components: {
	  swiper,
	  swiperSlide
  },
  computed: {
      swiper() {
    	return this.$refs.mySwiper.swiper
      }
  },
  data() {

	  return {
		bannerList:[],
		swiperOption: {
			slidesPerView:1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
            }
			
		},
  	  }
  },
  created() {
	this.getData();
  },
  methods: {
	  getData() {
		  var obj = this;
		  this.$form.sendPost({},'setting/getIntro',function(resp) {
				
				obj.bannerList = resp.banners;
				if(obj.bannerList.length<1) {
					localStorage.setItem('intro','used');
					obj.$router.push({path:'/member/login'})
				}

		  },'multi');
		
	  },
	  start() {
		 localStorage.setItem('intro','used');
		 this.$router.push({path:'/member/login'})
	  }
	  
  },
  mounted() {
	
	$('body').css({'height':$(window).height(),'overflow':'hidden'});	
  },
  updated() {
	 
	  var lastIndex = this.bannerList.length -1;
	  this.$refs.mySwiper.swiper.on('slideChange', function () {
		if(lastIndex == this.activeIndex) {
			$('#start-button-box .md-button').show();
		} else {
			$('#start-button-box .md-button').hide();
		}
	 });
	// $('.swiper-container .swiper-slide div').css('height',$(window).height());
 
  },
  beforeDestroy() {
	$('body').css({'height':'auto','overflow':'visible'});	
  }
 
}
</script>
<style lang="scss" scoped>
.page-container {
	height:calc(100vh);
	min-height:calc(100vh);
	overflow:hidden;
	width:calc(100vw);
	position:fixed;
	top:0;
	left:0;
	background:rgba(0,0,0,0.5);
	z-index:1000;
	.md-content {
		width:800px;
		height:600px;
		margin:100px auto;
		padding:0;
		position:relative;
		.swiper-container {
			margin:0;
			padding:0;
			position:relative;
			width:800px;
			background:#fff;
			height:600px;
			overflow:hidden;
			.swiper-slide {
				width:100%;
				margin:0;
				img {
					width:100%;
					min-height:600px;
				}
			}
		}
		#start-button-box {
			position:absolute;
			bottom:0;
			width:100%;
			height:45px;
			z-index:100;
			.md-button {
				margin:0 auto;
				padding:0;
				background:#27108C;
				z-index:1000;
				width:100%;
				height:45px;
				display:none;
			}
		}
	}
}
</style>
